export default __webpack_public_path__ + "static/media/home_hero_still.45d0e548.jpg";